import { role } from "./util/role";
import type { Role } from "./util/role";

let toolkitRealtimeClientId: string | null = null;

function createRandomHexId(): string {
  const cryptoObject = globalThis.crypto;
  if (typeof cryptoObject?.randomUUID === "function") {
    return cryptoObject.randomUUID().replace(/-/g, "");
  }

  if (typeof cryptoObject?.getRandomValues === "function") {
    const values = new Uint8Array(16);
    cryptoObject.getRandomValues(values);

    let result = "";
    for (const value of values) {
      result += value.toString(16).padStart(2, "0");
    }

    return result;
  }

  throw new Error("toolkit realtime client ids require crypto randomness");
}

export function createToolkitRealtimeClientId(clientRole: Role): string {
  return `${clientRole}_dojo_realtime_${createRandomHexId()}`;
}

export function getToolkitRealtimeClientId(): string | null {
  if (!role) {
    return null;
  }

  if (!toolkitRealtimeClientId) {
    toolkitRealtimeClientId = createToolkitRealtimeClientId(role);
  }

  return toolkitRealtimeClientId;
}

export function isLocalToolkitRealtimeSource(senderId: unknown): boolean {
  if (typeof senderId !== "string") {
    return false;
  }

  return senderId === getToolkitRealtimeClientId();
}
